// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"z7-z"};